<template>

  <div class="card card-front front-card">
    <header class="card-header">
      <div class="status right-status" :style="{'background-color': $store.getters.getStatusOfRoom(room.did).color}" style="margin-left: 75%;"></div>
      <div class="ob-header card-header">
        <div class="card-title">
          <h3>{{clauses.equip}}</h3>
          <h6>{{truncate(room.info.hvacName, 30, 27)}}</h6>
          <h6 style="color:lightblue;" v-if="room.info.apid">{{clauses.serial}}: {{room.info.apid}}</h6>
        </div>
        <div class="ob-img" style="justify-content:center;align-items:center;">
          <h3 style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;margin-left:10px;">{{room.info.altConfig}}</h3>
        </div>
      </div>
      <div class="card-head-sep"></div>
    </header>
    <div class="card-body side-body">
      <div class="card-info double-info">
        <div class="maint-header">
          <div :class="active === 'asset' ? 'maint-node active-maint-node' : 'maint-node'" @click="active = 'asset'">
            <h5>{{clauses.asset}}</h5>
          </div>
          <div :class="active === 'duty' ? 'maint-node active-maint-node' : 'maint-node'" @click="active = 'duty'">
            <h5>{{clauses.duty}}<br />{{$store.state.lang === 'en' ? '&' : 'と'}} {{clauses.runtime}}</h5>
          </div>
        </div>
        <div class="card-head-sep" style="margin-top:10px;"></div>
        <div class="maint-body" v-if="active === 'asset'">
          <div v-for="prop in equipProps()" class="alert-node equip-node">
            <div class="alert-head">
              <h6>{{prop.label}}</h6>
            </div>
            <h5>{{prop.val}}</h5>
          </div>
        </div>
        <div class="maint-body" style="justify-content:center;align-items:center;margin-bottom:15%;" v-else>
          <img src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/comingSoon.png" />
        </div>
        <div class="parent-overlay" style="align-items:center;background:rgba(0,0,0,0.65);" v-if="parent && parent.info">
          <img class="p-or-c" v-if="parent && parent.info" src="https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/child.png" />
            <h3 style="text-align:center;padding:5px;line-height:25px;">Area Supplied by<br/><span :style="{color: $store.getters.rdgStatus({rdg: 'days', did: parent.did}).color}">{{truncate(parent.info.hvacName, 25, 21)}}</span></h3>
        </div>
      </div>
    </div>
    <toggle-component :curr="3" v-on:flip="$emit('initFlip', {from: 'right', to: $event})"></toggle-component>
  </div>

</template>

<script>

import Lang from '@/lib/langTemplates/CardTemplate';

import Toggle from './Toggle';

export default {

  data(){
    return {
      active: 'asset',
      parent: {}
    }
  },

  props: ['room', 'status'],

  components: {
    'toggle-component': Toggle
  },

  computed: {
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    truncate(name, max, end){
      return name.length < max ? name : name.substr(0, end) + '...'
    },

    equipProps(){
      if (this.room.parent && typeof this.room.parent == 'string') this.parent = this.$store.getters.getParentRoom(this.room.parent) || false;
      const room = this[this.parent && this.parent.info ? 'parent' : 'room'];
      return [
        {
          label: this.clauses.manuf,
          prop: 'manufacturer'
        },
        {
          label: this.clauses.model,
          prop: 'modelNumber'
        },
        {
          label: this.clauses.fType,
          prop: 'fType'
        },
        {
          label: this.clauses.fBrand,
          prop: 'fBrand'
        },
        {
          label: this.clauses.fModel,
          prop: 'fModel'
        },
        {
          label: this.clauses.fSize,
          prop: 'altSize'
        },
      ].reduce((a, i) => {
        if (room.info[i.prop] && room.info[i.prop] !== ' ') {
          i.val = i.prop !== 'fType' ? room.info[i.prop] : room.info.fType;
        } else {
          i.val = 'not specified';
        }
        a.push(i);
        return a;
      }, []);
    }

  },

  mounted(){
    if (this.room.parent && typeof this.room.parent == 'string') this.parent = this.$store.getters.getParentRoom(this.room.parent) || false;
  }

}

</script>

<style>

.equip-node {
  border: 1px solid #dce1ec;
  height: 40px;
  margin: 3px;
}

.equip-node .alert-head {
  background-color: #dce1ec;
  color: rgb(2, 27, 47);
}

</style>



// WEBPACK FOOTER //
// src/components/card/Right.vue